/**
 * Explicit waits are waits that you explicitly tell to start and stop with
 * the explicit wait actions. Examples include switching tasks in a lesson
 * and the loading message that appears in parent portal.
 */
import { connect } from 'react-redux';
import {
    getExplicitWaitMessage,
    getExplicitWaitTransparent,
    getExplicitWaitVisible,
} from 'phoenix2/state/wait/selectors';

import Wait from './wait.jsx';

export const mapStateToProps = state => ({
    message: getExplicitWaitMessage(state),
    transparent: getExplicitWaitTransparent(state),
    visible: getExplicitWaitVisible(state),
    fadeIn: false,
    fadeOut: true,
});

export const connectExplicitWait = connect(mapStateToProps, null);

export const ExplicitWait = connectExplicitWait(Wait);
export default ExplicitWait;
